<template>
  <div id="footer" class="container-fluid">
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} luobidavip 版权所有</p>
    <p class="copy">联系电话：400-1786888</p>
    <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2024104609号-1</a>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
  padding-bottom: 20px;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue